/* Artavia: menu główne na komputerze
   - najechanie myszą rozwija podmenu,
   - kliknięcie w pozycję główną otwiera jej stronę (kolekcję),
   - klawiatura i ekrany dotykowe działają jak wcześniej (klik rozwija). */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var CLOSE_DELAY = 150;

  function setOpen(details, open) {
    var summary = details.querySelector(':scope > summary');
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init() {
    var items = document.querySelectorAll('.header__inline-menu header-menu > details');
    items.forEach(function (details) {
      if (details.dataset.artaviaHover) return;
      details.dataset.artaviaHover = '1';
      var summary = details.querySelector(':scope > summary');
      var timer;

      details.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        items.forEach(function (other) {
          if (other !== details && other.hasAttribute('open')) setOpen(other, false);
        });
        setOpen(details, true);
      });

      details.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          setOpen(details, false);
        }, CLOSE_DELAY);
      });

      if (!summary) return;
      summary.addEventListener(
        'click',
        function (event) {
          if (!mq.matches) return;
          var href = summary.getAttribute('data-href');
          if (!href || href === '#') return;
          // event.detail === 0 oznacza Enter/spację z klawiatury: zostawiamy rozwijanie
          if (event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
